import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './plugins/base'

import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)

import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

import Viewer from 'v-viewer'
Vue.use(Viewer)
import 'viewerjs/dist/viewer.css'

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
 
Vue.component('apexchart', VueApexCharts)

window.axios = require('axios')
import axios from 'axios'

import VMaps from 'v-maps'
const googleApiOptions = { key: 'YOUR_GOOGLE_MAPS_API_KEY' }
Vue.use(VMaps, googleApiOptions)
//test
// Vue.prototype.baseURL = 'http://192.168.49.51:3000' // URL for File retriving Globaly initialized
// axios.defaults.baseURL = 'http://192.168.49.51:3000' 

//Production
axios.defaults.baseURL = 'http://35.154.249.155';
Vue.prototype.baseURL = "http://35.154.249.155"
Vue.prototype.imageURL = "http://35.154.249.155/u/"

// Vue.prototype.baseURL = 'http://65.0.104.164' // URL for File retriving Globaly initialized
// axios.defaults.baseURL = 'http://65.0.104.164' //Development Server URL
axios.defaults.timeout = 60000;



Vue.config.productionTip = false

new Vue({
    vuetify,
    store,
    router,
   
    render: h => h(App)
}).$mount('#app')
